export default __webpack_public_path__ + "static/media/metamask.8e0a494c.svg";